package com.evoapps.evoshift.domain.usecase.roster

import com.evoapps.evoshift.domain.model.BusyElsewhere
import com.evoapps.evoshift.domain.model.User
import com.evoapps.evoshift.domain.repository.ShiftRepository
import kotlinx.datetime.DatePeriod
import kotlinx.datetime.LocalDate
import kotlinx.datetime.plus

/**
 * SH-135: the shifts [team] has at their other workplaces in a roster's month (and the day before
 * and after, for the rest around them), for the roster builder at [workplaceId]. From the server
 * (findBusyElsewhere): the same owner's drafts too, another employer's only once published and
 * only the times. People with no other workplace are not asked about.
 */
class GetBusyElsewhereUseCase(private val shiftRepository: ShiftRepository) {
    suspend operator fun invoke(workplaceId: String, team: List<User>, year: Int, month: Int): Result<List<BusyElsewhere>> {
        val withOthers = team.filter { user -> user.engagements.values.any { it.isActive && it.workplaceId != workplaceId } }.map { it.uid }
        return forPeople(workplaceId, withOthers, year, month)
    }

    /**
     * SH-267: the same for [userIds] as they are: people borrowed from another workplace of the
     * group (whose engagements here are the picker's, in memory) work elsewhere by definition.
     */
    suspend fun forPeople(workplaceId: String, userIds: List<String>, year: Int, month: Int): Result<List<BusyElsewhere>> {
        val withOthers = userIds.distinct()
        if (withOthers.isEmpty()) return Result.success(emptyList())
        val first = LocalDate(year, month, 1)
        val from = first.plus(DatePeriod(days = -1))
        val to = first.plus(DatePeriod(months = 1))
        return shiftRepository.findBusyElsewhere(workplaceId, withOthers, from.toString(), to.toString())
    }
}
